import { AfterViewInit, Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-dohot-bizoim-azmanot-table-data',
	template: `
		<ng-container *ngIf="showPreviousData; else normalData">
			<span class="bold invalid-color">
				{{ currentData | number : '1.0-2' }}
			</span>
			<span>({{ previousData | number : '1.0-2' }})</span>
		</ng-container>
		<ng-template #normalData>
			{{ currentData | number : '1.0-2' }}
		</ng-template>
	`,
})
export class DohotBizoimAzmanotTableDataComponent implements OnInit {
	@Input() previousData: number | null;
	@Input() currentData: number;

	showPreviousData = false;

	ngOnInit(): void {
		this.previousData = +Intl.NumberFormat('he-IL', { maximumFractionDigits: 2 }).format(this.previousData);
		if (this.previousData != null && this.previousData !== this.currentData) {
			this.showPreviousData = Math.abs(this.previousData - this.currentData) > 0.1;
		}
	}
}
